/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import _ from "lodash";
import { Accordion, Card } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import { getDealerInfo } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { connect } from "react-redux";
import Partners from "components/dealerInfo/Partners";
import "components/dealerInfo/DealerInfo.css";
import { Trans } from "react-i18next";

class DealerInfo extends Component {
  state = {
    dealerInfoFetched: false,
    toggledClassnames: {},
  };

  componentDidMount() {
    if (!this.props.dealerInfo) {
      this.fetchData();
    } else {
      this.onSuccess();
    }
    this.setState({
      toggledClassnames: {
        general: "btn btn-link collapsed",
        vehicle: "btn btn-link collapsed",
        dealer: "btn btn-link collapsed",
        management: "btn btn-link collapsed",
        regionManagement: "btn btn-link collapsed",
        partners: "btn btn-link collapsed",
      },
    });
  }

  componentDidUpdate(prevProps, prevState) {
  }

  fetchData = () => {
    this.props.getDealerInfo(
      this.props.onProcessBegin,
      this.onSuccess,
      this.onError
    );
  };

  onSuccess = () => {
    this.setState({ dealerInfoFetched: true });
    this.props.onProcessEnd();
  };

  onError = (err) => {
    this.props.onProcessEnd();
    console.log(err);
  };

  handleAccordionToggle = (eventkey) => {
    // console.log(eventkey);
    let tempToggledClassnames = this.resetAllClassNames();
    if (this.state.toggledClassnames[eventkey].indexOf("collapsed") > 0) {
      tempToggledClassnames[eventkey] = "btn btn-link";
    } else {
      tempToggledClassnames[eventkey] = "btn btn-link collapsed";
    }
    this.setState({
      toggledClassnames: { ...tempToggledClassnames },
    });
  };

  resetAllClassNames = () => {
    let tmp = { ...this.state.toggledClassnames };
    return _.forIn(tmp, (v, k) => {
      tmp[k] = "btn btn-link collapsed";
      // console.log(tmp[k]);
    });
  };

  renderData = () => {
    if (!this.state.dealerInfoFetched) return null;
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        {/* <ActivitiesTable data={this.state.filteredActivitiesData} /> */}
        {/* {console.log(this.props.activities.data.activities)} */}
        <Accordion
          className="sssAccordion"
          activeKey={this.state.activeKey}
          defaultActiveKey="general"
        >
          <Card key="general">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="general"
                onClick={() => this.handleAccordionToggle("general")}
              >
                <button
                  className={this.state.toggledClassnames["general"]}
                  type="button"
                >
                  <Trans desc="Genel">10073</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"general"}>
              <Card.Body>
                <div className="dealerInfo_grid">
                  <div className="form-group">
                    <label htmlFor="isim">
                      <Trans desc="Ünvanı">10074</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="isim"
                      value={this.props.dealerInfo.legalName}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tckimlikno">
                      <Trans desc="Adı">10075</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tckimlikno"
                      value={this.props.dealerInfo.name}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="egitimDurumu">
                      <Trans desc="Ana Telefon">10076</Trans>
                    </label>
                    <div className="inner-addon right-addon">
                      <input
                        type="text"
                        className="form-control"
                        id="education"
                        value={this.props.dealerInfo.mainPhone}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Diğer Telefon">10077</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.otherPhone
                          ? this.props.dealerInfo.otherPhone
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Fax">10078</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.faxNumber
                          ? this.props.dealerInfo.faxNumber
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Adres">10079</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.address}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Şehir">10080</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.city}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="E-Posta">10081</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.emailAddress}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Web Site">10082</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.webSite}
                      disabled
                    />
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card key="vehicle">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="vehicle"
                onClick={() => this.handleAccordionToggle("vehicle")}
              >
                <button
                  className={this.state.toggledClassnames["vehicle"]}
                  type="button"
                >
                  <Trans desc="Binek ve Ticari Araç Bilgileri">10083</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"vehicle"}>
              <Card.Body>
                <div className="dealerInfo_grid">
                  <div className="form-group">
                    <label htmlFor="isim">
                      <Trans desc="Lift Sayısı">10084</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="isim"
                      value={this.props.dealerInfo.numberOfLift}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tckimlikno">
                      <Trans desc="Base Sayısı">10085</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tckimlikno"
                      value={this.props.dealerInfo.numberOfBase}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="egitimDurumu">
                      <Trans desc="Showroom">10086</Trans>
                    </label>
                    <div className="inner-addon right-addon">
                      <input
                        type="text"
                        className="form-control"
                        id="education"
                        value={
                          this.props.dealerInfo.showRoom
                            ? this.props.dealerInfo.showRoom.toFixed(0)
                            : ""
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Yedek Parça">10087</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.sparePart
                          ? this.props.dealerInfo.sparePart.toFixed(0)
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Servis">10088</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.service
                          ? this.props.dealerInfo.service.toFixed(0)
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Toplam Kapalı Alan">10089</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.totalOutdoorSpace
                          ? this.props.dealerInfo.totalOutdoorSpace.toFixed(0)
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card key="dealer">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="dealer"
                onClick={() => this.handleAccordionToggle("dealer")}
              >
                <button
                  className={this.state.toggledClassnames["dealer"]}
                  type="button"
                >
                  <Trans desc="Bayi Bilgileri">10090</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"dealer"}>
              <Card.Body>
                <div className="dealerInfo_grid">
                  <div className="form-group">
                    <label htmlFor="isim">
                      <Trans desc="Yetkili Bayi Satış Kodu">10091</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="isim"
                      value={this.props.dealerInfo.authorizedDealerSalesCode}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tckimlikno">
                      <Trans desc="Yetkili Bayi Servis Kodu">10092</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tckimlikno"
                      value={this.props.dealerInfo.authorizedDealerServiceCode}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="egitimDurumu">
                      <Trans desc="Bölge">10093</Trans>
                    </label>
                    <div className="inner-addon right-addon">
                      <input
                        type="text"
                        className="form-control"
                        id="education"
                        value={
                          this.props.dealerInfo.region
                            ? this.props.dealerInfo.region.label
                            : ""
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Vergi Dairesi">10094</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.taxDepartment}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Vergi Numarası">10095</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.taxNo}
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Ticaret Sicil Numarası">10096</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={this.props.dealerInfo.chamberNumber}
                      disabled
                    />
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card key="management">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="management"
                onClick={() => this.handleAccordionToggle("management")}
              >
                <button
                  className={this.state.toggledClassnames["management"]}
                  type="button"
                >
                  <Trans desc="Bayi Yönetim Kadrosu">10097</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"management"}>
              <Card.Body>
                <div className="dealerInfo_grid">
                  <div className="form-group">
                    <label htmlFor="isim">
                      <Trans desc="Şube Müdürü">10098</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="isim"
                      value={
                        this.props.dealerInfo.branchManager
                          ? this.props.dealerInfo.branchManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tckimlikno">
                      <Trans desc="Genel Müdür">10099</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tckimlikno"
                      value={
                        this.props.dealerInfo.generalManager
                          ? this.props.dealerInfo.generalManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="egitimDurumu">
                      <Trans desc="Satış Müdürü">10100</Trans>
                    </label>
                    <div className="inner-addon right-addon">
                      <input
                        type="text"
                        className="form-control"
                        id="education"
                        value={
                          this.props.dealerInfo.salesManager
                            ? this.props.dealerInfo.salesManager.name
                            : ""
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Servis Müdürü">10101</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.serviceManager
                          ? this.props.dealerInfo.serviceManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Yedek Parça Müdürü">10102</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.sparePartManager
                          ? this.props.dealerInfo.sparePartManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card key="regionManagement">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="regionManagement"
                onClick={() => this.handleAccordionToggle("regionManagement")}
              >
                <button
                  className={this.state.toggledClassnames["regionManagement"]}
                  type="button"
                >
                  <Trans desc="Ford Otosan Bölge Müdürü Kadrosu">10103</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"regionManagement"}>
              <Card.Body>
                <div className="dealerInfo_grid">
                  <div className="form-group">
                    <label htmlFor="isim">
                      <Trans desc="Perakende Satış Bölge Müdürü">10104</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="isim"
                      value={
                        this.props.dealerInfo.retailSalesRegionManager
                          ? this.props.dealerInfo.retailSalesRegionManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="tckimlikno">
                      <Trans desc="İkinci El ve Ekspertiz Bölge Müdürü">
                        10105
                      </Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="tckimlikno"
                      value={
                        this.props.dealerInfo.secondHandExpertiseRegionManager
                          ? this.props.dealerInfo
                            .secondHandExpertiseRegionManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="egitimDurumu">
                      <Trans desc="Satış Sonrası Bölge Müdürü">10106</Trans>
                    </label>
                    <div className="inner-addon right-addon">
                      <input
                        type="text"
                        className="form-control"
                        id="education"
                        value={
                          this.props.dealerInfo.afterSalesRegionManager
                            ? this.props.dealerInfo.afterSalesRegionManager.name
                            : ""
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="pozisyon">
                      <Trans desc="Filo Satış Bölge Müdürü">10107</Trans>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pozisyon"
                      value={
                        this.props.dealerInfo.fleetSalesRegionManager
                          ? this.props.dealerInfo.fleetSalesRegionManager.name
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card key="partners">
            <Card.Header>
              <Accordion.Toggle
                as="h2"
                className="mb-0"
                eventKey="partners"
                onClick={() => this.handleAccordionToggle("partners")}
              >
                <button
                  className={this.state.toggledClassnames["partners"]}
                  type="button"
                >
                  <Trans desc="Bayi Ortakları">10400</Trans>
                </button>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={"partners"}>
              <Card.Body>
                <Partners partners={this.props.dealerInfo.partners} />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  };

  render() {
    return (
      <section className="sssArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#" style={{ verticalAlign: "middle" }}>
                    <Trans desc="Şirket Bilgileri">10024</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Bayi Bilgileri">10031</Trans>
                </li>
              </ul>
            </div>
          </div>

          <div className="row py-4 bottomRow">{this.renderData()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ dealerInfo, application }) => {
  return {
    dealerInfo: dealerInfo.data.data,
    application,
  };
};

export default connect(mapStateToProps, { getDealerInfo })(
  containsLongRunningProcess(requireAuth(DealerInfo))
);
